<template>
    <div class="card">
        <div class="card-header">
            <h2 class="card-title fw-bolder">{{ $t('pages.module.eTep.question.save.questionType.paragraphDragCorrectSort.title') }}</h2>
        </div>
        <div class="card-body d-flex flex-column p-9">
            <div class="row">
                <div class="col-md-12">
                    <div class="fv-row">
                        <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.eTep.question.save.questionType.paragraphDragCorrectSort.paragraph') }}</label>
                        <el-form-item prop="data.data.content" :rules="$validation.getMessage(['required'])">
                            <CustomCkeditor :model="data.content" @updateModel="data.content = $event"></CustomCkeditor>
                        </el-form-item>
                        <el-form-item :label="$t('pages.module.eTep.question.save.questionType.paragraphDragCorrectSort.dragContentCount')" prop="data.data.drag_content_count" :rules="$validation.getMessage(['required'])">
                            <el-input-number v-model="data.drag_content_count" :min="1"/>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card mt-7" v-if="updateStatus">
        <div class="card-header">
            <h2 class="card-title fw-bolder">{{ $t('pages.module.eTep.question.save.questionType.paragraphDragCorrectSort.answer.title') }}</h2>
        </div>
        <div class="card-body">
            <div class="row" v-if="answers?.length">
                <div v-for="(answer, answerIndex) in answers" :key="answerIndex" class="col-md-12" :class="[(answerIndex > 0 ? 'mt-md-20' : 'mt-md-0'), answerIndex !== 0 && 'mt-20' ]">
                    <div class="mb-2 d-flex justify-content-between align-items-center">
                        <div class="text-gray-800 fs-4 fw-bolder">
                            {{ sprintf($t('pages.module.eTep.question.save.questionType.paragraphDragCorrectSort.answer.titlePattern'), [(answerIndex + 1)]) }}
                        </div>
                        <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteAnswer(answer, answerIndex)">
                            <template #reference>
                                <button class="btn btn-danger btn-sm" type="button"><i class="bi bi-trash"/> Kaldır</button>
                            </template>
                        </el-popconfirm>
                    </div>
                    <div class="border border-gray-300 pt-5 px-3 pb-0 rounded">
                        <div class="fv-row mb-1">
                            <el-form-item :prop="'data.answers[' + answerIndex + '].data.content'" :rules="$validation.getMessage(['required'])">
                                <CustomCkeditor :model="answer.data.content" @updateModel="answer.data.content = $event"></CustomCkeditor>
                            </el-form-item>
                            <el-form-item :prop="'data.answers[' + answerIndex + '].sort'" :rules="$validation.getMessage(['required'])">
                                <el-input-number v-model="answer.sort" :min="1"/>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="d-flex flex-column align-items-center justify-content-center py-5">
                <p class="text-gray-600 text-center">{{ $t('pages.module.eTep.question.save.questionType.paragraphDragCorrectSort.answer.answerAddContent') }}</p>
                <button class="btn btn-flex btn-primary me-2" v-on:click="addAnswer()" type="button">
                    <span class="svg-icon svg-icon-2">
                        <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                    </span>
                    {{ $t('pages.module.eTep.question.save.questionType.paragraphDragCorrectSort.answer.add') }}
                </button>
            </div>
        </div>
        <div class="card-footer" v-if="answers?.length">
            <button class="btn btn-flex btn-primary me-2" v-on:click="addAnswer()" type="button">
                <span class="svg-icon svg-icon-2">
                    <inline-svg src="/media/icons/duotune/arrows/arr075.svg"/>
                </span>
                {{ $t('pages.module.eTep.question.save.questionType.paragraphDragCorrectSort.answer.add') }}
            </button>
        </div>
    </div>
</template>

<script>
import CustomCkeditor from "@/components/custom-ckeditor/index.vue";
import md5 from 'md5'

export default {
    name: "ParagraphDragCorrectSort",
    props: {
        data: Object,
        answers: Array,
        updateStatus: Boolean,
        correctAnswer: Array
    },
    data() {
        return {
            paragraphPreview: true,
        }
    },
    components: {
        CustomCkeditor
    },
    methods: {
        addContent(type) {
            if (type === 'paragraph') {
                this.data.contents.push({
                    "type": type,
                    "content": ""
                })
            } else if (type === 'drag_content') {
                this.data.contents.push({
                    "type": type,
                    "hash": this.generateHash(),
                })
            }
        },
        deleteContent(paragraph, paragraphIndex) {
            this.data.contents.splice(paragraphIndex, 1);
        },
        generateHash() {
            const timestamp = Date.now().toString()
            const random = Math.random().toString(36).substring(2, 10)
            const input = `${timestamp}-${random}`
            this.paragraphPreview = true
            return md5(input);
        },
        addAnswer() {
            let answerLength = this.answers.length;
            this.answers.push({
                data: {
                    content: ''
                },
                sort: answerLength !== 0 ? (this.answers[answerLength - 1].sort + 1) : 1,
            })
        },
        deleteAnswer(value, index) {
            if (value.id) {
                this.$store.dispatch("module/etep/question/answer/delete", {
                    id: [value.id]
                }).then((successDeleted) => {
                    if (successDeleted) {
                        this.$emit('load-question', true)
                    }
                });
            } else {
                this.answers.splice(index, 1);
            }
        }
    }
};
</script>
